/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-named-as-default-member */
import React, { useState } from 'react';
import {
  Box, Button, Grid, makeStyles, TextField, Typography,
  MenuItem, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel,
} from '@material-ui/core';
import {
  EmailValidation, PhoneValidation, ActivityValidation, CnpjValidation,
} from '../functions/FormValidation';
import { ActivityOptions } from '../functions/Options';
import Hubspot from '../functions/Hubspot';
import TextFieldStatus from '../atoms/TextFieldStatus';
import MaskedTextField from '../molecules/MaskedTextField';
import InputWrap from '../atoms/InputWrap';
import WhatsappIcon from '../atoms/icons/WhatsappIcon';

class FormValidator {
  static validateEmail(email) {
    if (!email) {
      return 'E-mail é obrigatório';
    }
    try {
      if (!EmailValidation({ email })) {
        return 'E-mail inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'E-mail inválido';
    }
  }

  static validatePhone(phone) {
    if (!phone) {
      return 'Telefone é obrigatório';
    }
    try {
      if (!PhoneValidation({ phone })) {
        return 'Telefone inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'Telefone inválido';
    }
  }

  static validateActivity(activity) {
    if (!activity) {
      return 'Escolha a atividade.';
    }
    try {
      if (!ActivityValidation({ activity })) {
        return 'Escolha a atividade.';
      }
      return null;
    } catch (e) {
      return 'Escolha a atividade.';
    }
  }

  static validateBillingExpectation(billingExpectation) {
    if (!billingExpectation) {
      return 'Selecione uma das opções de faturamento.';
    }
    return null;
  }

  static validateCnpj(cnpj) {
    if (!cnpj) {
      return 'Digite o número do seu CNPJ.';
    }
    try {
      if (!CnpjValidation({ cnpj })) {
        return 'Digite o número do seu CNPJ.';
      }
      return null;
    } catch (e) {
      return 'Digite o número do seu CNPJ.';
    }
  }

  static validateField(fieldName, value) {
    switch (fieldName) {
      case 'email':
        return this.validateEmail(value);
      case 'phone':
        return this.validatePhone(value);
      case 'activity':
        return this.validateActivity(value);
      case 'monthly_billing_expectation':
        return this.validateBillingExpectation(value);
      case 'cnpj':
        return this.validateCnpj(value);
      default:
        return null;
    }
  }

  // type define os campos extras (TXM-368): abrir-empresa -> atividade +
  // faturamento; trocar-contador -> cnpj.
  static validateAll(data, type) {
    const errors = {};

    const emailError = this.validateEmail(data.email);
    if (emailError) errors.email = emailError;

    const phoneError = this.validatePhone(data.phone);
    if (phoneError) errors.phone = phoneError;

    if (type === 'abrir-empresa') {
      const activityError = this.validateActivity(data.activity);
      if (activityError) errors.activity = activityError;

      const billingError = this.validateBillingExpectation(data.monthly_billing_expectation);
      if (billingError) errors.monthly_billing_expectation = billingError;
    }

    if (type === 'trocar-contador') {
      const cnpjError = this.validateCnpj(data.cnpj);
      if (cnpjError) errors.cnpj = cnpjError;
    }

    return errors;
  }
}
const useStyles = makeStyles({
  root: {
    borderRadius: '16px',
    padding: '32px 40px 38px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 30px 70px rgba(58, 53, 104, 0.102)',
    position: 'relative',
  },
  title: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '19px',
  },
  select: {
    '& .MuiSelect-icon': {
      right: '24px',
    },
  },
  radio: {
    color: '#36344B',
    padding: 0,
    '&.Mui-checked': {
      color: '#4FA050',
    },
    '& .MuiSvgIcon-root': {
      width: '16px',
      height: '16px',
    },
  },
  button: {
    position: 'relative',
    width: '100%',
    background: '#0093F5',

    '&:hover': {
      background: '#0673BC',
    },

    '&:disabled': {
      background: '#BFD4E3',
    },

    '& .MuiButton-label': {
      color: '#FFFFFF',
      textWrapMode: 'nowrap',
    },

    '&.Mui-disabled:hover': {
      backgroundColor: '#BFD4E3',
    },
  },
});

/**
 * @param {{
 *  originModal?: (open: boolean) => void,
 * tagWpp?: () => void
 * tagWppId?: string
 * type?: 'abrir-empresa' | 'trocar-contador'
 * notConvert?: boolean
 * }} props
 */
export default function FormButtonWhatsappOnly({
  originModal, isColumn, tagWpp = () => {}, tagWppId, onSucess = () => {}, type = 'abrir-empresa', notConvert = false,
}) {
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [errorRoot, setErrorRoot] = useState();
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const changeData = (value, field) => {
    const newData = { ...data, [field]: value };
    setData(newData);

    const error = FormValidator.validateField(field, value);

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (error) {
        newErrors[field] = error;
      } else {
        delete newErrors[field];
      }
      return newErrors;
    });
  };

  const validateForm = () => {
    const newErrors = FormValidator.validateAll(data, type);
    setErrors(newErrors);
    return newErrors;
  };

  // Verifica se o formulário está totalmente válido
  const isFormValid = () => {
    // Verifica se não há erros de validação
    const hasNoErrors = Object.keys(errors).length === 0;

    // Campos base (todos os contextos): telefone + e-mail
    let allFieldsValid = data.email && data.phone && hasNoErrors
      && !FormValidator.validateEmail(data.email)
      && !FormValidator.validatePhone(data.phone);

    // Campos extras por contexto (TXM-368)
    if (type === 'abrir-empresa') {
      allFieldsValid = allFieldsValid
        && data.activity && data.monthly_billing_expectation
        && !FormValidator.validateActivity(data.activity)
        && !FormValidator.validateBillingExpectation(data.monthly_billing_expectation);
    }

    if (type === 'trocar-contador') {
      allFieldsValid = allFieldsValid
        && data.cnpj
        && !FormValidator.validateCnpj(data.cnpj);
    }

    return allFieldsValid;
  };

  const handleSubmit = async () => {
    setErrorRoot(undefined);
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setIsLoading(true);

    try {
      await Hubspot.sendToHubspotForm(type, {
        ...data,
        customer_service: 'Via Whatsapp',
      });

      // Dispara um submit REAL no <form>: as variaveis nativas Form ID/Element
      // do GTM so sao preenchidas por um submit de DOM real, nao por push
      // manual no dataLayer. O onSubmit do form faz preventDefault, entao nao
      // ha navegacao real da pagina.
      const formEl = typeof document !== 'undefined'
        ? document.getElementById((function () {
          if (notConvert) return 'contato-wpp';
          return type === 'abrir-empresa' ? 'form-open-company' : 'form-trocar-contador';
        }()))
        : null;
      if (formEl) {
        formEl.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }

      if (notConvert) {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'contato-wpp',
          formId: 'contato-wpp',
          'gtm.element': formEl,
          'gtm.elementId': 'contato-wpp',
          formData: {
            data,
          },
        });
      }

      if (!notConvert) {
        if (type === 'abrir-empresa') {
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: 'form-open-company',
            formId: 'form-open-company',
            'gtm.element': formEl,
            'gtm.elementId': 'form-open-company',
            formData: {
              data,
            },
          });
        }

        if (type === 'trocar-contador') {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'form-trocar-contador',
            formId: 'form-trocar-contador',
            'gtm.element': formEl,
            'gtm.elementId': 'form-trocar-contador',
            formName: 'Contato',
            formData: {
              data,
            },
          });
        }
      }

      onSucess();
      setIsLoading(false);
      setData({
        firstname: '', email: '', phone: '', city: '', state: '', activity: '', cityName: '', monthly_billing_expectation: '', cnpj: '',
      });
      setErrors({});
      originModal && originModal(false);
      window.location.href = `https://api.whatsapp.com/send/?phone=${process.env.GATSBY_WHATSAPP_BUSINESS}&text=Falar%20com%20Especialista&type=phone_number&app_absent=0`;
    } catch (error) {
      setErrorRoot('Desculpe, ocorreu um erro. Tente novamente mais tarde!');
    } finally {
      setIsLoading(false);
    }
  };

  // Botão desabilitado quando: está carregando OU o formulário não está válido
  const disabled = isLoading || !isFormValid();

  return (
    <Box className={classes.root}>
      <form
        id={(function () {
          if (notConvert) return 'contato-wpp';
          return type === 'abrir-empresa' ? 'form-open-company' : 'form-trocar-contador';
        }())}
        // O botao NAO dispara submit de proposito (type=button + onClick):
        // o coletor de forms do HubSpot captura o evento de submit, e este form
        // nao deve mais ser coletado (o lead vai via API pro form nativo).
        onSubmit={(e) => e.preventDefault()}
      >
        <Typography className={classes.title}>
          Preencha as informações abaixo
          e fale com nosso time!
        </Typography>

        <Box style={{ padding: '32px 0' }}>
          <InputWrap column={isColumn}>
            <MaskedTextField
              onChange={(e) => changeData(e.target.value, 'phone')}
              mask="+55 (99) 99999-9999"
              textFieldProps={{
                label: 'Telefone',
                name: 'phone',
                type: 'tel',
                value: data.phone,
                floating: true,
                error: Boolean(errors.phone),
                helperText: errors.phone,
              }}
              placeholder="+55 (DDD) 00000-0000"
              InputLabelProps={{
                shrink: true,
                error: false,
                focused: false,
              }}
              InputProps={{
                disabled: isLoading,
                endAdornment: (
                  <TextFieldStatus
                    error={Boolean(errors.phone)}
                    value={data.phone && !errors.phone}
                  />
                ),
              }}
            />
            <TextField
              label="E-mail"
              name="email"
              type="email"
              value={data.email}
              onChange={(e) => changeData(e.target.value, 'email')}
              error={Boolean(errors.email)}
              helperText={errors.email}
              disabled={isLoading}
              placeholder="seu_email@mail.com.br"
              InputLabelProps={{
                shrink: true,
                error: false,
                focused: false,
              }}
              InputProps={{
                endAdornment: (
                  <TextFieldStatus
                    error={Boolean(errors.email)}
                    value={data.email && !errors.email}
                  />
                ),
              }}
            />
            {type === 'abrir-empresa' && (
              <>
                <TextField
                  label="Qual será a atividade? *"
                  name="activity"
                  value={data.activity || ''}
                  onChange={(e) => changeData(e.target.value, 'activity')}
                  disabled={isLoading}
                  className={classes.select}
                  placeholder="Ex: programador, designer"
                  InputLabelProps={{ shrink: true, error: false, focused: false }}
                  error={Boolean(errors.activity)}
                  helperText={errors.activity}
                  InputProps={{
                    endAdornment: (
                      <TextFieldStatus
                        error={Boolean(errors.activity)}
                        value={data.activity && !errors.activity}
                      />
                    ),
                  }}
                  select
                  SelectProps={{
                    displayEmpty: true,
                    renderValue: (selected) => {
                      if (!selected) {
                        return (
                          <span style={{ color: 'rgba(0, 0, 0, 0.3)' }}>
                            Ex: programador, designer
                          </span>
                        );
                      }
                      return data.activity;
                    },
                  }}
                >
                  {ActivityOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <FormControl
                  component="fieldset"
                  error={Boolean(errors.monthly_billing_expectation)}
                  disabled={isLoading}
                  style={{ width: '100%' }}
                >
                  <FormLabel
                    component="legend"
                    style={{
                      fontSize: '0.75rem',
                      fontWeight: 400,
                      transform: 'none',
                      color: 'rgba(0, 0, 0, 0.54)',
                    }}
                  >
                    Qual a sua expectativa de faturamento mensal? *
                  </FormLabel>
                  <RadioGroup
                    row
                    name="monthly_billing_expectation"
                    value={data.monthly_billing_expectation || ''}
                    onChange={(e) => changeData(e.target.value, 'monthly_billing_expectation')}
                    style={{ gap: '2px', marginTop: '8px' }}
                  >
                    <FormControlLabel
                      value="Até R$ 6 mil"
                      style={{ marginLeft: 0 }}
                      control={<Radio className={classes.radio} style={{ marginRight: '8px' }} />}
                      label={<Typography style={{ fontSize: '0.75rem', color: '#383743' }}>Até R$ 6 mil</Typography>}
                    />
                    <FormControlLabel
                      value="Acima de R$ 6 mil"
                      style={{ marginLeft: 0 }}
                      control={<Radio className={classes.radio} style={{ marginRight: '8px' }} />}
                      label={<Typography style={{ fontSize: '0.75rem', color: '#383743' }}>Acima de R$ 6 mil</Typography>}
                    />
                  </RadioGroup>
                  {errors.monthly_billing_expectation && (
                    <Typography variant="caption" style={{ color: '#f44336' }}>
                      {errors.monthly_billing_expectation}
                    </Typography>
                  )}
                </FormControl>
              </>
            )}
            {type === 'trocar-contador' && (
              <MaskedTextField
                onChange={(e) => changeData(e.target.value, 'cnpj')}
                mask="99.999.999/9999-99"
                textFieldProps={{
                  label: 'CNPJ',
                  name: 'cnpj',
                  type: 'text',
                  value: data.cnpj,
                  floating: true,
                  error: Boolean(errors.cnpj),
                  helperText: errors.cnpj,
                }}
                placeholder="00.000.000/0000-00"
                InputLabelProps={{ shrink: true, error: false, focused: false }}
                InputProps={{
                  disabled: isLoading,
                  endAdornment: (
                    <TextFieldStatus
                      error={Boolean(errors.cnpj)}
                      value={data.cnpj && !errors.cnpj}
                    />
                  ),
                }}
              />
            )}
          </InputWrap>
        </Box>
        {errorRoot && <Typography component="span" style={{ color: '#D12E26' }}>{errorRoot}</Typography>}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id={tagWppId}
              className={classes.button}
              disabled={disabled}
              style={{ height: '55px' }}
              type="button"
              onClick={() => {
                tagWpp();
                handleSubmit('Via Whatsapp');
              }}
              startIcon={(
                <WhatsappIcon
                  height="fit-content"
                />
            )}
            >
              FALAR VIA WHATSAPP
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
